import type { HandlingUnitHashMap, PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { isPackingListRowEmpty } from "@RequestFormV2/sections/PackingList/utils/isRowEmpty";
import { isContainerRow } from "@RequestFormV2/sections/PackingList/utils/packingListSplit";
import { validatePackingListRow } from "@RequestFormV2/validation/sections/packingListFieldRules";
import { isEmptyValue } from "@RequestFormV2/validation/utils/validationMessages";

export function getPackingListRequiredHintPaths(
  row: PackingListRow,
  index: number,
  handlingUnitHashMap: HandlingUnitHashMap,
  hasAttemptedReview: boolean,
  nmfcNumberEnabled?: string | null,
): string[] {
  const rulesContext = { nmfcNumberEnabled };
  const hasTypeSelected = isContainerRow(row)
    ? !isEmptyValue(row.container_type)
    : !isEmptyValue(row.handling_unit);

  if (!hasAttemptedReview) {
    if (!hasTypeSelected) return [];
    return validatePackingListRow(row, index, handlingUnitHashMap, rulesContext);
  }

  if (isPackingListRowEmpty(row)) return [];

  return validatePackingListRow(row, index, handlingUnitHashMap, rulesContext);
}
